import { render, staticRenderFns } from "./sectionInfo.vue?vue&type=template&id=2fbab9e3&scoped=true"
import script from "./sectionInfo.vue?vue&type=script&lang=js"
export * from "./sectionInfo.vue?vue&type=script&lang=js"
import style0 from "./sectionInfo.vue?vue&type=style&index=0&id=2fbab9e3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbab9e3",
  null
  
)

export default component.exports